import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
/** @format */

import { PageHeader } from '@ant-design/pro-layout';
import { Grid, Layout, Skeleton } from 'antd';
import ImpendingMessage from '../../shared/maintenance-message/impending-message';
import MaintenanceMessage from '../../shared/maintenance-message/maintenance-message';
import useMaintenanceMessage from '../../shared/maintenance-message/use-maintenance-message';
import { FooterLayout } from './components/footer';
import HeaderLogoLayout from './components/header';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const SectionLayout: React.FC<any> = (_props) => {
  const screens = useBreakpoint();
  const { isImpending, isMaintenance } = useMaintenanceMessage();
  const handleLogin = () => {
    window.location.href = `${import.meta.env.VITE_LOGIN_REDIRECT_URI}`;
  };
  const loginLayout = (
    <>
      <div style={{ width: '100%' }}>
        <div style={{ margin: 'auto', marginTop: '10px', textAlign: 'center', borderRadius: '0 0 0.8rem 0.8rem' }}>
          {/* <hr style={{ backgroundColor: '#3f4373' }} /> */}
          <div>
            <Typography.Title level={2}>CASE MANAGEMENT PORTAL</Typography.Title>
            <br />
            <div style={{ textAlign: 'center' }}>
              <Button size="large" type="primary" onClick={() => handleLogin()} style={{ minWidth: '150px', fontSize: '18px' }}>
                Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Layout style={{ minHeight: '100vh', width: '100%', overflowX: 'clip', display: 'flex', flexDirection: 'column' }}>
      <>
        <HeaderLogoLayout />
        <PageHeader style={{ backgroundColor: '#3f4373' }}>
          <div style={{ marginLeft: screens.md ? '9px' : '-10px', paddingBottom: '12px', height: '40px' }}></div>
        </PageHeader>
      </>

      <Content
        className="site-layout"
        style={{
          padding: screens.lg ? '0 50px' : '0 5px',
          display: 'flex',
          width: '100%'
        }}
      >
        <div
          className="site-layout-background"
          style={{
            paddingLeft: screens.lg ? '40px' : '10px',
            paddingRight: screens.lg ? '40px' : '10px'
          }}
        >
          {isMaintenance === undefined ? (
            <Skeleton />
          ) : isMaintenance ? (
            <MaintenanceMessage />
          ) : isImpending === undefined ? (
            <Skeleton />
          ) : isImpending ? (
            <div className="custom-impending">
              <ImpendingMessage isRootPage />
              <Row justify={'center'}>
                <Col>{loginLayout}</Col>
              </Row>
            </div>
          ) : (
            <Row justify={'center'}>
              <Col>{loginLayout}</Col>
            </Row>
          )}
        </div>
      </Content>
      <FooterLayout />
    </Layout>
  );
};
